import { createSlice } from '@reduxjs/toolkit';
import {
  createCategory,
  deleteCategory,
  fetchCategories,
  updateCategory
} from './category.actions';

const initialState = {
  categories: [],
  metaData: { total: 0, page: 1, perPage: 10 },

  isLoadingCreateCategory: false,
  isLoadingFetchCategories: false,
  isLoadingUpdateCategory: false,
  isLoadingDeleteCategory: false
};

const categorySlice = createSlice({
  name: 'category',
  initialState,
  reducers: {
    clearCategoryState: () => initialState
  },
  extraReducers: (builder) => {
    builder.addCase(createCategory.pending, (state) => {
      state.isLoadingCreateCategory = true;
    });
    builder.addCase(createCategory.fulfilled, (state) => {
      state.isLoadingCreateCategory = false;
    });
    builder.addCase(createCategory.rejected, (state) => {
      state.isLoadingCreateCategory = false;
    });

    builder.addCase(fetchCategories.pending, (state) => {
      state.isLoadingFetchCategories = true;
    });
    builder.addCase(fetchCategories.fulfilled, (state, action) => {
      state.categories = action.payload.data;
      state.metaData = action.payload.metaData;
      state.isLoadingFetchCategories = false;
    });
    builder.addCase(fetchCategories.rejected, (state) => {
      state.isLoadingFetchCategories = false;
    });

    builder.addCase(updateCategory.pending, (state) => {
      state.isLoadingUpdateCategory = true;
    });
    builder.addCase(updateCategory.fulfilled, (state) => {
      state.isLoadingUpdateCategory = false;
    });
    builder.addCase(updateCategory.rejected, (state) => {
      state.isLoadingUpdateCategory = false;
    });

    builder.addCase(deleteCategory.pending, (state) => {
      state.isLoadingDeleteCategory = true;
    });
    builder.addCase(deleteCategory.fulfilled, (state) => {
      state.isLoadingDeleteCategory = false;
    });
    builder.addCase(deleteCategory.rejected, (state) => {
      state.isLoadingDeleteCategory = false;
    });
  }
});

export const { clearCategoryState } = categorySlice.actions;

export default categorySlice.reducer;
